import { render, staticRenderFns } from "./CarrierServiceSettingEditForm.vue?vue&type=template&id=13bbe347&scoped=true&"
import script from "./CarrierServiceSettingEditForm.vue?vue&type=script&lang=js&"
export * from "./CarrierServiceSettingEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbe347",
  null
  
)

export default component.exports